import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ErrorBoundary from "./components/errorBoundary/ErrorBoundary";

import PrivateRoute from "./auth/PrivateRoute";

// Layout
import AdminLayout from "./layout/admin";
import AuthLayout from "./layout/auth";

import "rsuite/dist/rsuite.min.css";
import NotFoundPage from "./pages/notFound";
import TvPage from "./pages/tv/TvPage";

function App() {
  return (
    <ErrorBoundary>
      <Routes>
        {/*
          ⚠ `+ window.location.search` não é enfeite: sem ele, quem chega em `/?code=…` (o retorno
          do login pela Microsoft) perde a query no redirecionamento, e a tela de login abre como se
          nada tivesse acontecido. O retorno agora aponta direto para /auth/sign-in, e isto fica
          como rede para qualquer link que ainda caia na raiz com parâmetros.
        */}
        <Route
          path="/"
          element={<Navigate to={`/auth/sign-in${window.location.search}`} replace />}
        />

        <Route path="auth/*" element={<AuthLayout />} />
        <Route
          path="admin/*"
          element={<PrivateRoute component={AdminLayout} />}
        />
        {/* TV pública: autentica pela chave na URL, fora do PrivateRoute. */}
        <Route path="tv/:codigo" element={<TvPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
